<template>
  <div class="evaluation-choose">
    <nav-bar
      fixed
      z-index="99"
      :title="title"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="$router.go(-1)"
      right-text="个人中心"
      @click-right="$router.push('/user')"
    />
    <div
      class="evaluation-choose-head"
      :style="`background-image: url(${headerImg});`"
    >
      <div class="evaluation-choose-head-title">
        <p>{{ title }}</p>
      </div>
    </div>
    <div class="evaluation-choose-content">
      <EvaluationBox
        class="evaluation-choose-content-item"
        title="选择测评入口"
        v-if="!isPay"
      >
        <!-- {{ cardCategoryList }} -->
        <div>
          <!-- <div style="margin-bottom: 10px;color: #333;text-align: center;"> -->
          <div style="margin-bottom: 10px">
            <notice-bar
              color="#fff"
              background="rgb(169,178,219)"
              style="border-radius: 20px"
              :scrollable="false"
            >
              <template #left-icon>
                <Icon class="flash-ani" name="volume-o"></Icon>
              </template>
              <Swipe
                vertical
                class="notice-swipe"
                :autoplay="3000"
                :show-indicators="false"
              >
                <SwipeItem>选一个你感兴趣的水滴进行评测</SwipeItem>
                <SwipeItem>选一个你感兴趣的水滴进行评测</SwipeItem>
              </Swipe>
            </notice-bar>
          </div>
          <FlowerBox
            ref="flowerBox"
            :list="cardCategoryList"
            @confirmResult="confirmResult"
            @confirmFlower="confirmFlower"
            @cancelResult="cancelResult"
          />

          <div
            class="evaluation-choose-content-item-footer"
            id="intro-doc-position"
            style="position: relative; z-index: 1"
            v-show="showPersonType"
          >
            <div class="evaluation-choose-content-item-footer-box">
              <div
                v-for="item in paperList"
                :key="item.id"
                style="text-align: center"
                :style="{ width: paperList.length == 1 ? '100%' : '40%' }"
              >
                <div
                  class="evaluation-choose-content-item-footer-box-btn"
                  :style="{
                    'background-color':
                      currentType.personType == item.id
                        ? 'rgb(239,182,28)'
                        : 'rgb(254,199,55)',
                  }"
                  @click="changePersonType(item)"
                >
                  <div>
                    {{ item.name }}
                  </div>
                </div>
                <div v-if="item.name == '家长版'">从家长视角看孩子</div>
                <div v-else-if="item.name == '青年版'">由青少年自己填写</div>
              </div>

              <div v-if="paperList.length == 0">
                当前类型下没有试卷，请重新选择其他试卷
              </div>
            </div>
          </div>

          <!-- <div
            class="evaluation-choose-content-item-footer"
            style="
              position: relative;
              z-index: 1;
              color: #000;
              font-weight: 600;
            "
            v-show="showPersonType"
          >
            <div class="evaluation-choose-content-item-footer-box">
              您选择的是: {{ title }}
            </div>
          </div> -->
        </div>
      </EvaluationBox>

      <div
        v-show="title != '测评介绍' && !isPay"
        style="
          background: rgb(169, 178, 219);
          border-radius: 0.08rem;
          padding: 0.08rem 0.15rem;
        "
      >
        <div
          style="
            background-color: #fff;
            border-radius: 5rem;
            font-size: 0.3rem;
            padding: 0.1rem 0.35rem;
            color: rgb(0, 0, 0);
            font-weight: 600;
            border: 0 solid blue;
          "
        >
          您选择的是: {{ title }}
        </div>
      </div>

      <EvaluationBox
        class="evaluation-choose-content-item"
        title="测评介绍"
        v-show="intro != '' && !isPay"
      >
        <div v-html="intro"></div>
      </EvaluationBox>
      <EvaluationBox
        class="evaluation-choose-content-item"
        title="购买须知"
        v-show="intro != '' && !isPay"
      >
        <div v-html="reviewConfig.purchase_notes"></div>
      </EvaluationBox>
      <EvaluationBox
        class="evaluation-choose-content-item"
        title="测前须知"
        v-if="isPay"
      >
        <div v-html="reviewBefore"></div>
      </EvaluationBox>
    </div>

    <div class="evaluation-choose-self">
      <!-- <span class="evaluation-choose-self-btn" v-show="showEnterBtn" @click="goEvaluation" v-if="!isPay">进入测评</span>
      <div class="evaluation-choose-self-btn" @click="startEvaluation" v-else>开始测评</div> -->
      <span
        class="evaluation-choose-self-text"
        @click="$router.push('/evaluation/my')"
        v-if="!isPay"
        >我的测评</span
      >
      <div class="evaluation-choose-self-btn" @click="startEvaluation" v-else>
        开始测评
      </div>
    </div>

    <div class="evaluation-choose-footer" v-if="!isPay && showEnterBtn">
      <div class="evaluation-choose-footer-start" @click="goEvaluation">
        立即测评
      </div>
      <!-- <div v-else class="evaluation-choose-footer-start" @click="$router.push('/evaluation/my')">
        我的测评
      </div> -->
      <!-- <div class="evaluation-choose-footer-start" @click="$router.push('/evaluation/my')">
        我的测评
      </div> -->
    </div>
  </div>
</template>

<script>
import EvaluationBox from "@/components/evaluation/EvaluationBox.vue";
import FlowerBox from "@/components/evaluation/FlowerBox.vue";
import { Icon } from "vant";
import {
  getCardCategoryList,
  getPaperList,
  pay as payOrder,
  create as createOrder,
  getReviewConfig,
  getPaperInfo,
  paperCheck,
} from "@/api/evaluation";
import { getSystemConfig } from "@/api/public";
import { isWeixin } from "@utils";
import { pay } from "@libs/wechat";
import { NavBar, NoticeBar, Swipe, SwipeItem } from "vant";
export default {
  data() {
    return {
      headerImg: "",
      cardCategoryList: [],
      paperList: [],
      showPersonType: false,
      showEnterBtn: false,
      isPay: false,
      currentType: {
        data: {},
        personType: null,
        paperList: [],
        paperItem: {
          id: null,
        },
      },
      payType: isWeixin() ? "weixin" : "weixinh5",
      intro: "",
      reviewConfig: {},
      payResult: {},
      reviewBefore: "",
      title: "测评介绍",
    };
  },
  components: {
    EvaluationBox,
    FlowerBox,
    NavBar,
    NoticeBar,
    Swipe,
    SwipeItem,
    Icon,
  },
  mounted() {
    // 页面加载时获取参数和配置
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get("cateId")){
      this.currentType.data.id= urlParams.get("cateId");
      this.title = urlParams.get("title");
      var prame =  {
        id: urlParams.get("type"),
        name: urlParams.get("name")
      }
      this.changePersonType(prame);
    }

    this.getSystemConfig();
    this.getCardCategoryList();
    this.getReviewConfig().then(() => {
      if (this.$route.query.orderId) {
        this.isPay = true;
        this.getPaperInfo();
      }
    });

  },
  methods: {
    // 获取头部图片配置
    getSystemConfig() {
      getSystemConfig({ name: "evaluation_header_img" }).then((res) => {
        this.headerImg = res.data;
      });
    },
    // 初始化获取配置列表
    getCardCategoryList() {
      getCardCategoryList().then((res) => {
        res.data = res.data.map((item) => {
          if (item.children.length == 0) {
            item.children = [{ ...item }];
          }
          return item;
        });
        const list = res.data || [];
        // 截取前9个
        this.cardCategoryList = list.slice(0, 9);
      });
    },
    // 确定选中类型
    confirmResult(result) {
      this.showPersonType = true;
      this.currentType.data = result;
      // 重置
      this.currentType.personType = null;
      this.intro = "";

      this.paperList = [];
      this.paperList = result.children;
      if (this.title.split(" - ").length > 1) {
        this.title = this.title.split(" - ")[0] + " - " + result.name;
        return;
      }
      // 获取父类型
      this.title = this.title + " - " + result.name;
    },
    // 选中花瓣
    confirmFlower(item) {
      this.title = item.name;
    },
    // 取消选中类型
    cancelResult() {
      this.showPersonType = false;
      this.currentType.data = {};
      this.currentType.personType = null;
      this.paperList = [];
      this.intro = "";
    },
    // 选中家长版等类型时候触发
    changePersonType(item) {
      this.currentType.personType = item.id;
      this.$refs.flowerBox.closeOverlay();
      this.getPaperList();
      if (this.title.split(" - ").length > 2) {
        console.log(this.title.split(" - "));
        this.title =
          this.title.split(" - ")[0] +
          " - " +
          this.title.split(" - ")[1] +
          " - " +
          item.name;
        return;
      }
      this.title = this.title + " - " + item.name;
    },
    // 获取家长版等类型下的试卷，目前默认为第一套
    getPaperList() {
      this.$dialog.loading.open();

      const data = {
        cateId: this.currentType.data.id,
        paperTypeId: this.currentType.personType,
      };
      getPaperList(data)
        .then((res) => {
          this.$dialog.loading.close();
          if (res.data.length == 0) {
            this.$dialog.toast({
              mes: "当前类型下没有试卷，请重新选择其他试卷",
            });
          } else {
            this.currentType.paperList = res.data;
            this.intro = res.data[0].paperDesc;
            this.showEnterBtn = true;
            console.log("选完了");
            this.goPosition();
          }
        })
        .catch((err) => {
          this.$dialog.loading.close();
        });
    },
    paperHandle(item) {
      this.currentType.paperItem = item;
      this.showEnterBtn = true;
    },
    async goEvaluation() {
      // this.getPaperInfo(2);
      // return
      const res = await paperCheck({
        id: this.currentType.paperList[0].id,
      });
      console.log(res);
      if (res.data) {
        this.$dialog.confirm({
          mes: "该模块已完成测评，是否重新评测？",
          opts: () => {
            this.payEvaluation();
          },
        });
        return;
      } else {
        this.payEvaluation();
      }
    },
    async payEvaluation() {
      this.$dialog.loading.open("支付中...");
      // 开始进行判断，拉起支付等
      const params = {
        from: "weixin",
        paperId: this.currentType.paperList[0].id,
        payType: "weixin",
      };
      createOrder(params)
        .then((res) => {
          // console.log("res", res);
          this.$dialog.loading.close();
          const data = res.data;
          // 首次不用支付直接跳转
          if (data.paid == 1) {
            this.payResult = data;
            this.isPay = true;
            this.getPaperInfo(data.result.orderId);
            return;
          }
          switch (data.status) {
            case "ORDER_EXIST":
            case "EXTEND_ORDER":
            case "PAY_DEFICIENCY":
            case "PAY_ERROR":
              this.$dialog.toast({ mes: res.msg });
              // this.$router.replace({
              //   path: "/order/status/" + data.result.orderId,
              //   query: { type: this.type },
              // });
              break;
            case "SUCCESS":
              this.payResult = data;
              this.$toast("支付成功");
              this.isPay = true;
              this.getPaperInfo(this.payResult.result.orderId);
              break;
            case "WECHAT_PAY":
              // 吊起支付
              pay(data.result.jsConfig)
                .then(() => {
                  this.payResult = data;
                  this.$toast("支付成功");
                  this.isPay = true;
                  this.getPaperInfo(this.payResult.result.orderId);
                })
                .catch(() => {
                  this.$dialog.toast({ mes: "支付失败" });
                });
          }
        })
        .catch((err) => {
          this.$dialog.toast({ mes: "订单/支付失败" });
          this.$dialog.loading.close();
        });
    },
    // 配置文本
    getReviewConfig() {
      return new Promise((resolve, reject) => {
        getReviewConfig().then((res) => {
          this.reviewConfig = res.data;
          resolve(res);
        });
      });
    },
    startEvaluation() {
      if (this.$route.query.orderId) {
        this.$router.push({
          path: "/evaluation/detail",
          query: {
            orderId: this.$route.query.orderId,
          },
        });
        return;
      } else {
        this.$router.push({
          path: "/evaluation/detail",
          query: {
            orderId: this.payResult.result.orderId,
          },
        });
      }
    },
    getPaperInfo(orderId) {
      const data = {
        orderId: orderId || this.$route.query.orderId,
      };
      getPaperInfo(data)
        .then((res) => {
          const paperInfo = res.data;
          let reviewBefore = this.reviewConfig.review_before_notes;
          reviewBefore = reviewBefore.replace("#{time}", paperInfo.paperTime);
          reviewBefore = reviewBefore.replace(
            "#{num}",
            paperInfo.questionCount
          );
          this.reviewBefore = reviewBefore;
          this.title = `${paperInfo.oneCateName} - ${paperInfo.paperName} - ${paperInfo.cateName}`;
        })
        .catch((err) => {
          this.$toast(err.msg);
        });
    },
    // 屏幕滑动到指定位置
    goPosition() {
      const position = document.getElementById("intro-doc-position");
      const getOffsetTopByBody = (el) => {
        let offsetTop = -50;
        while (el && el.tagName !== "BODY") {
          offsetTop += el.offsetTop;
          el = el.offsetParent;
        }
        return offsetTop;
      };
      this.$nextTick(() => {
        window.scrollTo({
          top: getOffsetTopByBody(position),
          behavior: "smooth", // 开启平滑滚动
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation-choose {
  background-color: #fff;

  &-head {
    background-image: url("~@/assets/evaluation/header.png");
    height: 2.3rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;

    &-title {
      position: absolute;
      top: 0.97rem;
      left: 0.6rem;
      color: rgb(255, 196, 0);
      font-weight: bold;
      font-family: DINAlternate-Bold;
      font-size: 0.35rem;
      width: 4.5rem;
    }
  }

  &-content {
    padding: 0.2rem 0.3rem;

    &-item {
      margin: 0.3rem 0;

      &-footer {
        padding: 0.2rem 0.3rem;
        border-top: 0.01rem solid #eee;
        font-size: 0.25rem;
        color: #666;
        background-color: #fff;
        border-radius: 0.25rem;
        z-index: 2;
        margin-top: 0.2rem;

        &-box {
          display: flex;
          justify-content: space-between;
          &-btn {
            color: #fff;
            background-color: rgb(244, 90, 85);
            border-radius: 2rem;
            font-size: 0.3rem;
            width: 100%;
            text-align: center;
            padding: 0.1rem;
          }
          &-type {
            margin-top: 0.1rem;
          }
        }
      }

      &-paper {
        padding: 0.2rem 0.3rem;
        border: 0.01rem solid #eee;
        border-radius: 0.25rem;
        background-color: #fff;
        margin-top: 0.2rem;

        &-title {
          font-size: 0.3rem;
          color: #333;
          padding: 0.1rem 0;
        }

        &-list {
          &-item {
            background-color: rgb(244, 244, 244);
            border-radius: 0.1rem;
            padding: 0.1rem;
            margin: 0.1rem 0;
          }

          &.active {
            font-weight: bold;
          }
        }
      }
    }
  }

  &-self {
    font-size: 0.25rem;
    color: #666;
    display: flex;
    justify-content: center;
    padding: 0.2rem 0 0.8rem 0;
    padding-bottom: 2rem;

    &-text {
      text-align: center;
      border-bottom: 0.03rem solid #666;
      padding-bottom: 0.05rem;
    }

    &-btn {
      padding: 0.2rem 0.8rem;
      background-color: rgb(255, 200, 55);
      color: black;
      border-radius: 2rem;
      font-size: 0.25rem;
    }
  }

  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.2rem;
    background-color: rgb(255, 200, 55);
    z-index: 3;
    display: flex;
    align-items: center;
    padding: 0rem 0.3rem;

    &-start {
      width: 100%;
      background-color: #fff;

      font-size: 0.3rem;
      font-weight: bold;
      border-radius: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.35rem;
      padding: 0.1rem 0.35rem;
      color: #000;

      // box-shadow: 3px 3px 7px rgba(0, 0, 0, .4), 1px 1px 1px rgba(255, 255, 255, .9);
      border: 2px solid #ccc;
      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(255, 196, 0) !important;
}

.notice-swipe {
  height: 25px;
  line-height: 25px;
}
.van-notice-bar {
  height: 25px;
}

// 闪烁动画
.flash-ani {
  animation: flash 1s linear infinite;
  margin-right: 0.1rem;
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
